module.exports = __webpack_public_path__ + "08_mole.9da89c71.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer3/08_mole.png
// module id = MCk5
// module chunks = 0